// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum EndpointAttachmentType {
	None = 0,
	Photo = 1,
	Video = 2,
}

export const EndpointAttachmentTypeDisplayNames: { [key in keyof typeof EndpointAttachmentType]?: string} = {
	"None": "None",
	0 : "None",
	"Photo": "Photo",
	1 : "Photo",
	"Video": "Video",
	2 : "Video",
}

export const getEndpointAttachmentTypeDisplayName = (key: EndpointAttachmentType | (keyof typeof EndpointAttachmentType & string)) => {
	return EndpointAttachmentTypeDisplayNames[key];
}

